import { Typography, Stack } from "@mui/material";

const InfoField = ({
  label,
  value,
  valueJsx,
}: {
  label: string;
  value?: string | null | undefined;
  valueJsx?: React.ReactNode;
}) => (
  <Stack>
    <Typography variant="subtitle2" color="text.secondary" fontSize="0.75rem">
      {label}
    </Typography>
    {valueJsx ?? (
      <Typography
        variant="subtitle2"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        fontWeight={500}
        title={value || "Unknown"}
      >
        {value || "Unknown"}
      </Typography>
    )}
  </Stack>
);

export default InfoField;
